<!--<div class="modal-header">-->
<!--  <h4 class="modal-title"></h4>-->
<!--  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">-->
<!--    <span aria-hidden="true">&times;</span>-->
<!--  </button>-->
<!--</div>-->
<div [ngClass]="options$.class" class="modal-body">
  <!-- Use ng-template to ensure that the generated components end up in the right place -->
  <ng-template #container></ng-template>
</div>
<!--<div class="modal-footer">-->
<!--  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>-->
<!--</div>-->
